// extracted by mini-css-extract-plugin
export default {"recoCarousel":"SX-z","fullMaxWidth":"TX-z","displayTwoCardTilesMobile":"UX-z"};